import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("trellure_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function uploadFile(url, file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  return client.post(url, form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
}

export default client;
